export const ASCENDING = 'ascending';
export const DESCENDING = 'descending';

export const FIRST_PAGE = 1;
